import React from "react";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

import {
  getKoraxModeColors,
  koraxTokens
} from "../../designSystem";

const useStyles = makeStyles(theme => {
  const modeColors = getKoraxModeColors(theme.mode);

  return {
    mainContainer: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      minHeight: 0,
      height: "100%",
      boxSizing: "border-box",

      paddingTop: koraxTokens.layout.contentPaddingDesktop,
      paddingRight: koraxTokens.layout.contentPaddingDesktop,
      paddingBottom: koraxTokens.layout.contentPaddingDesktop,
      paddingLeft: koraxTokens.layout.contentPaddingDesktop,

      backgroundColor: modeColors.background,

      [theme.breakpoints.down("md")]: {
        paddingTop: koraxTokens.layout.contentPaddingTablet,
        paddingRight: koraxTokens.layout.contentPaddingTablet,
        paddingBottom: koraxTokens.layout.contentPaddingTablet,
        paddingLeft: koraxTokens.layout.contentPaddingTablet
      },

      [theme.breakpoints.down("sm")]: {
        paddingTop: koraxTokens.layout.contentPaddingMobile,
        paddingRight: koraxTokens.layout.contentPaddingMobile,
        paddingBottom: koraxTokens.layout.contentPaddingMobile,
        paddingLeft: koraxTokens.layout.contentPaddingMobile
      }
    },

    noPadding: {
      padding: 0
    },

    constrained: {
      "& > $contentWrapper": {
        width: "100%",
        maxWidth: koraxTokens.layout.contentMaxWidth,
        marginLeft: "auto",
        marginRight: "auto"
      }
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box"
    },

    scrollable: {
      overflowY: "auto",
      overflowX: "hidden"
    },

    hiddenOverflow: {
      overflow: "hidden"
    }
  };
});

const MainContainer = ({
  children,
  className,
  disablePadding = false,
  fullWidth = true,
  scroll = false,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Container
      maxWidth={false}
      disableGutters
      className={clsx(
        classes.mainContainer,
        disablePadding && classes.noPadding,
        !fullWidth && classes.constrained,
        className
      )}
      {...rest}
    >
      <div
        className={clsx(
          classes.contentWrapper,
          scroll ? classes.scrollable : classes.hiddenOverflow
        )}
      >
        {children}
      </div>
    </Container>
  );
};

export default MainContainer;
